// This enum describes authentication types shown to user.
export enum AuthenticationTypeOption {
    SkyKickAuth = 0,
    SkyKickAuthWithMFA = 1,
    M365Auth = 2
}
